// 接口代理路径
export const BASE_URL = process.env.NODE_ENV === 'production' ? '' : '/devapi'

// 请求接口超时时间
export const TIMEOUT = 8000